import React from "react";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const AcompanamientoOrgExport = ({ dataSource }) => {

    const exportToExcel = async () => {
        if (!dataSource || dataSource.length === 0) {
            console.warn("No hay datos para exportar.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("AcompañamientoOrg");

        // Definir columnas a combinar (merge)
        const columnsToMerge = ["Proyecto", "Sub-Región", "Departamento", "Municipio", "Zona", "Línea Productiva", "Organización", "Mes / Año",
            "Día", "Acompañamiento Técnico", "Capacitación", "Total", "Temáticas",
            "Plan de Acompañamiento", "N° Planes Acompañamiento", "Reunión Socialización", "N° Reuniones Socialización",
            "Plan de Compras", "N° Planes Compras"];

        // Definir encabezados
        const headers = [
            "Proyecto", "Sub-Región", "Departamento", "Municipio", "Zona", "Línea Productiva", "Organización", "Mes / Año",
            "Día", "Acompañamiento Técnico", "Capacitación", "Total", "Temáticas",
            "Plan de Acompañamiento", "N° Planes Acompañamiento", "Reunión Socialización", "N° Reuniones Socialización",
            "Plan de Compras", "N° Planes Compras"
        ];

        // Agregar encabezados a la hoja de cálculo
        worksheet.addRow(headers);

        // Aplicar estilos a las cabeceras
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "338bc7" } };
            cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            cell.border = {
                top: { style: "thin", color: { argb: "000000" } },
                left: { style: "thin", color: { argb: "000000" } },
                bottom: { style: "thin", color: { argb: "000000" } },
                right: { style: "thin", color: { argb: "000000" } }
            };
        });

        // Agregar datos a la hoja de cálculo
        const exportData = dataSource.map((row) => [
            row.proyecto, row.subregion, row.departamento, row.municipio, row.zona, row.linea_p, row.organizacion, row.mes,
            row.dia, row.acompanamiento, row.capacitacion, row.totalPorRegistro, row.tematica,
            row.plan_acompa_obs, row.plan_acompa_num, row.reunion_socializa_obs, row.reunion_socializa_num,
            row.plan_compras_obs, row.plan_compras_num
        ]);

        exportData.forEach((dataRow) => {
            worksheet.addRow(dataRow);
        });

        // Aplicar estilos de alineación y bordes a todas las celdas de contenido
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return; // Saltamos la cabecera

            row.eachCell((cell, colNumber) => {
                let alignment = "left";

                // Aplicar alineación específica por columna
                if (["Zona", "Acompañamiento Técnico", "Capacitación", "Total"].includes(headers[colNumber - 1])) {
                    alignment = "center";
                }

                cell.alignment = { horizontal: alignment, vertical: "middle", wrapText: true };

                // Aplicar bordes a todas las celdas
                cell.border = {
                    top: { style: "thin", color: { argb: "000000" } },
                    left: { style: "thin", color: { argb: "000000" } },
                    bottom: { style: "thin", color: { argb: "000000" } },
                    right: { style: "thin", color: { argb: "000000" } }
                };
            });
        });

        // Aplicar combinación de celdas según las columnas a mergear
        columnsToMerge.forEach((col, index) => {
            const colIndex = index + 1;
            let startRow = 2;
            let getCellValue = (row, col) => worksheet.getCell(row, col).value;
        
            // Determinar la columna de comparación
            let comparisonCol;
            if (colIndex < 7 || colIndex === 12) {
                comparisonCol = 7;
            } else if (colIndex === 13) {
                comparisonCol = 8;
            } else if (colIndex > 13) {
                comparisonCol = 7;
            } else {
                comparisonCol = colIndex;
            }
        
            let lastValue = getCellValue(startRow, comparisonCol);
        
            for (let i = 3; i <= worksheet.rowCount; i++) {
                let currentValue = getCellValue(i, comparisonCol);
        
                if (currentValue !== lastValue) {
                    if (colIndex < 9 || colIndex > 11) {
                        if (i - startRow > 1) {
                            worksheet.mergeCells(startRow, colIndex, i - 1, colIndex);
                        }
                    }
                    startRow = i;
                    lastValue = currentValue;
                }
            }
        
            // Verificar si se necesita un último merge al final
            if (colIndex < 9 || colIndex > 11) {
                if (worksheet.rowCount - startRow >= 1) {
                    worksheet.mergeCells(startRow, colIndex, worksheet.rowCount, colIndex);
                }
            }
        });
        

        // Ajustar automáticamente el ancho de las columnas
        worksheet.columns.forEach((column, index) => {
            column.width = headers[index].length + 5; // Ajustar ancho según el contenido
        });

        // Guardar archivo Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, "AcompañamientoOrg.xlsx");
    };

    return (
        <Button
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={exportToExcel}
            style={{ backgroundColor: "#28a745", borderColor: "#218838", color: "white" }}
        >
            Exportar a Excel
        </Button>
    );
};

export default AcompanamientoOrgExport;
